import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionBadge = ({ label, testId }) => (
  <span
    data-testid={testId}
    className="font-tech text-xs uppercase tracking-[0.2em] text-[#8C9A86]"
  >
    {label}
  </span>
);
